<template>
  <div id="player-training-load-table">
    <v-data-table
      :headers="tableHeadersMatch"
      :loading="loading"
      :items="stats"
      hide-default-footer
      :items-per-page="pagination.per_page"
      dense
      :custom-sort="customSort"
      sort-by="end_at"
    >
      <!--<editor-fold desc="ITEM SLOT">-->
      <template v-slot:item="{ item }">
        <player-match-table-row
          :data="item"
          :max-values="maxValues"
          :player="player"
          :table-headers="tableHeadersMatch"
        />
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="LOADING SLOT">-->
      <template slot="loading">
        <div
          class="pa-5 d-flex justify-center align-center"
          :style="'min-height: ' + (stats.length * 49)+'px'"
        >
          <v-progress-circular
            indeterminate
            size="48"
            width="4"
            color="grey lighten-2"
          />
        </div>
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="PROGRESS SLOT">-->
      <template slot="progress">
        <!-- override default progress bar -->
        <div />
      </template>
      <!--</editor-fold>-->
    </v-data-table>
    <div
      v-if="pagination && pagination.last_page && pagination.last_page > 1"
      class="d-flex justify-center align-center py-5"
    >
      <pagination
        v-model="pagination.current_page"
        :last-page="pagination.last_page"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import PlayerMatchTableRow from '@/components/players/PlayerMatchTableRow.vue'
import { cloneDeep } from 'lodash'

export default {
  name: 'PlayerMatchTable',
  components: { PlayerMatchTableRow, Pagination },
  props: {
    stats: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    maxValues: {
      type: Object,
      default: () => ({})
    },
    player: {
      type: Object,
      default: () => ({})
    },
    tableHeaders: {
      type: Array,
      required: true
    }
  },
  computed: {
    tableHeadersMatch() {
      const headers = cloneDeep(this.tableHeaders)

      headers.splice(1, 0, { text: this.$t('table_headers.main_load.pain'), value: 'pain' })
      headers.splice(1, 0, { text: this.$t('variables.TL'), value: 'load' })
      headers.splice(1, 0, { text: this.$t('event_type.match'), value: 'title' })

      return headers
    }
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        let aValue = null
        let bValue = null

        if (index[0] === 'end_at') {
          aValue = a.end_at
          bValue = b.end_at
        } else {
          aValue = a.player_stats[index]
          bValue = b.player_stats[index]
        }

        if (isDesc[0]) {
          if (aValue === null || aValue === undefined) return -1
          if (bValue === null || bValue === undefined) return 1
          return aValue > bValue ? 1 : -1
        } else {
          if (aValue === null || aValue === undefined) return 1
          if (bValue === null || bValue === undefined) return -1
          return aValue < bValue ? 1 : -1
        }
      })
      return items
    }
  }
}
</script>

<style scoped>

</style>
